var _mask, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStateOffIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_3_4096",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.26801 6.26801 0 14 0C21.732 0 28 6.26801 28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.26801 6.26801 0 14 0C21.732 0 28 6.26801 28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14Z",
    fill: "#C90000",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 14M28 14M28 14M0 14M14 0M28 14M14 28M0 14M14 28V26C7.37258 26 2 20.6274 2 14H0H-2C-2 22.8366 5.16344 30 14 30V28ZM28 14H26C26 20.6274 20.6274 26 14 26V28V30C22.8366 30 30 22.8366 30 14H28ZM14 0V2C20.6274 2 26 7.37258 26 14H28H30C30 5.16344 22.8366 -2 14 -2V0ZM14 0V-2C5.16344 -2 -2 5.16344 -2 14H0H2C2 7.37258 7.37258 2 14 2V0Z",
    fill: "#FB2C36",
    mask: "url(#path-1-inside-1_3_4096)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5341 12.6667C20.8385 14.1609 20.6215 15.7143 19.9193 17.0679C19.2171 18.4214 18.072 19.4934 16.6751 20.1049C15.2782 20.7164 13.7138 20.8305 12.2429 20.4282C10.772 20.026 9.48353 19.1316 8.59225 17.8943C7.70097 16.657 7.26081 15.1515 7.34518 13.6289C7.42954 12.1063 8.03332 10.6587 9.05583 9.52744C10.0783 8.39616 11.4578 7.64961 12.9641 7.4123C14.4704 7.17498 16.0126 7.46123 17.3334 8.22333",
    stroke: "#C90000",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.3334L14 15.3334L20.6667 8.66669",
    stroke: "#C90000",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStateOffIcon);
export default __webpack_public_path__ + "static/media/state_off_icon.99be93b33fe7f9f19c378920e40b023c.svg";
export { ForwardRef as ReactComponent };